import React from 'react'
import './Service.css'
import ContentBox from './ContentBox/ContentBox'

const Service = () => {

  return (
    <section className='Service'>

      <div className='container'>
        <div className='row'>
          <ContentBox
            stripColor = 'violet'
            title      = 'UX/UI Design'
            text       = '8 years experience with big projects'
            imgPath    = '/images/service/service_icon1.png'
          />
          <ContentBox
            stripColor = 'red'
            title      = 'Usability Testing'
            text       = 'Help you find the weakest parts in your UX at early stage'
            imgPath    = '/images/service/service_icon2.png'
          />
        </div>
      </div>
    </section>
  )
}

export default Service